
const Shader_TurbulentDisplace = {
vert:`

attribute vec3 aPosition;
attribute vec2 aUv0;

uniform mat4 matrix_model;
uniform mat4 matrix_viewProjection;
uniform float uTime;
uniform float strength;

varying vec2 vUv0;

void main(void)
{
    vec4 pos = matrix_model * vec4(aPosition, 1.0);
    pos.x += sin(uTime + pos.y * 4.0) * strength;
    pos.y += cos(uTime + pos.x * 4.0) * strength;
    vUv0 = aUv0;
    gl_Position = matrix_viewProjection * pos;
}
`,
frag:`
precision mediump float;

uniform sampler2D uDiffuseMap;

varying vec2 vUv0;

void main(void)
{
    gl_FragColor = texture2D(uDiffuseMap, vUv0);
}
`
};
// const Shader_TurbulentDisplace = {
//     vert: `
//     uniform mat4 matrix_viewProjection;
//     uniform mat4 matrix_model;


// uniform float waveWidth;
// uniform float waveHeight;
// uniform float speed;
// uniform float uTime;
// uniform float timeOffset;

// // Default attributes provided by THREE.js. Attributes are only available in the
// // vertex shader. You can pass them to the fragment shader using varyings
// attribute vec3 vertex_position;
// attribute vec2 vertex_texCoord0;

// // Examples of variables passed from vertex to fragment shader
// varying vec3 vvertex_position;

// varying vec2 vUv;
// varying vec2 vUv2;
// varying float vHeight;

// void main() {


//     vUv = vertex_texCoord0;
    
// 	vec4 v = vec4( vertex_position, 1.0 );
// 	float t = (uTime+timeOffset) * speed;
	
// 	v.z += (
// 	    // Add some offset to the waves to make it slightly less regular
// 	    sin(waveWidth * vertex_position.x + t * 1.3) *
// 	    cos(waveWidth * vertex_position.y + t * 0.9) * waveHeight
//     ) + (
//         // Extra waves to add interest
// 	    cos(waveWidth * 2.0 * vertex_position.x + t * -.3) *
// 	    sin(waveWidth * 4.0 * vertex_position.y + t * 3.9) * ( waveHeight / 2.0 )
//     );
//     vHeight = v.z;
    
//     gl_Position = matrix_viewProjection * matrix_model * v;
    
// }
//     `,
//     frag: `
//     precision highp float;
// precision highp int;

// uniform mat3 normalMatrix;
// uniform sampler2D image;
// uniform float opacity;

// varying float vHeight;
// varying vec2 vUv;


// void main() {

//     vec3 color = texture2D(
//         image, vUv
//     ).rgb;
    
//     gl_FragColor = vec4( color, opacity);
// }
//     `
// }
export { Shader_TurbulentDisplace };